import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

/**
 * Whether My campaigns is open in this build (campaign creator invitations, 2026-10-15).
 *
 * On everywhere, prod included, and deliberately independent of `IS_MARKETPLACE_ACTIVE`: a business
 * can put a creator on a campaign roster while browse/apply is still "Coming soon", and the creator
 * must be able to read that brief. Every surface that offers My campaigns reads this (the route, the
 * nav item), so closing it is one line. A function, like `isCollabPortfolioActive`, so specs can flip it.
 */
export const isMyCampaignsActive = (): boolean => true;

export const MY_CAMPAIGNS_PATH = '/campaigns/mine';

/** Route gate: when closed, a direct URL lands on Home. */
export const myCampaignsActiveGuard: CanMatchFn = () =>
  isMyCampaignsActive() || inject(Router).createUrlTree(['/dashboard']);
